import { HttpClient } from '@angular/common/http';
import { environment } from '@prcins/environments';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SessionService {
    constructor(http) {
        this.http = http;
    }
    transferSession(target, handler) {
        const URL = `${environment.BASE_URL}/session/redirect`;
        let { currentPolicy: selectedPolicy, userId } = sessionStorage;
        return this.http.post(URL, { target, handler, selectedPolicy, userId });
    }
    hydrateSession(session) {
        const URL = `${environment.BASE_URL}/session/restore?session=${session}`;
        return this.http.post(URL, {});
    }
}
SessionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SessionService_Factory() { return new SessionService(i0.ɵɵinject(i1.HttpClient)); }, token: SessionService, providedIn: "root" });
